import { BifrostBackendNestApi } from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";

const tenantId = appConfig.tenantId;

const FavoriteProductProvider = {
	addFavoriteProduct({ idpToken, productId, productTenantId }) {
		return BifrostBackendNestApi.post("/favorite-products", {
			productId,
			tenantId,
			productTenantId
		}, {
			headers: {
				Authorizationidp: idpToken
			}
		});
	},
	deleteFavoriteProduct({ idpToken, productId, productTenantId}) {
		return BifrostBackendNestApi.delete("/favorite-products", {
			headers: {
				Authorizationidp: idpToken
			},
			data: {
				productId,
				tenantId,
				productTenantId
			}
		});
	}
};

export default Object.freeze(FavoriteProductProvider);
